import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { webPageCity } from 'src/app/web-page-city.data';
import { WebPageCityComponent } from './web-page-city/web-page-city.component';
const routes: Routes = [];

webPageCity.map((element) => {
  routes.push({ path: `${element.url_name}`, component: WebPageCityComponent, data: { title: `${element.page_title}`, city_id: element.city_id } })
})

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class WebPageCityRoutingModule { }
